import React from 'react'

export default function Page({ title, icon: Icon, actions, children, className = '', description }) {
  return (
    <div className={["space-y-6", className].join(' ')}>
      {title || actions ? (
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          {title ? (
            <div>
              <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-3">
                {Icon && (
                  <div className="p-2 bg-blue-100 rounded-xl">
                    <Icon className="h-7 w-7 text-blue-600" />
                  </div>
                )}
                {title}
              </h1>
              {description && (
                <p className="text-gray-600 mt-2">{description}</p>
              )}
            </div>
          ) : <div />}
          {actions ? (
            <div className="flex items-center gap-2">{actions}</div>
          ) : null}
        </div>
      ) : null}
      {children}
    </div>
  )
}

